import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-translate';
import { Card, Container, Grid, Image, Segment } from 'semantic-ui-react';
import { addLanguage, addLogin, addRegister, addSelectedUserType } from '../../actions/AppActions';
import entreprises from '../../assets/img/entreprises.PNG';
import KnaufLogoCloud from '../../assets/img/KnaufLogoCloud.png';
import prescripteurs from '../../assets/img/prescripteurs.PNG';
import user from '../../assets/img/user.PNG';
import { isSignedIn, onSignOut } from '../../Auth';
import LoginComponent from './LoginComponent';
import './TypeUser.css';
import JobList from '../Protected/projet/jobList';

class ConnectedTypeUser extends Component {
  static propTypes = {
    t: PropTypes.func,
    app: {
      env: PropTypes.string,
    },
    addRegister: PropTypes.func,
    addSelectedUserType: PropTypes.func,
    addLogin: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      displayLogin: false,
    };
  }

  componentWillMount() {
    if (!isSignedIn() && (window.location.pathname === '/login')) {
      this.addLogin();
    }
  }

  signOut = () => {
    onSignOut();
    this.forceUpdate();
  }

  addRegister = () => {
    const { addRegister } = this.props;
    addRegister(true);
  }

  addLogin = (userType) => {
    const { addSelectedUserType, addLogin } = this.props;
    addSelectedUserType(userType);

    this.setState({
      displayLogin: true,
    });
  }

  onClose = () => {
    this.setState({ displayLogin: false });
  }

  render() {
    const { t } = this.props;
    const { displayLogin } = this.state;

    return (
      <Segment
        basic
        id="landingMain"
      >
        { displayLogin && (
          <LoginComponent
            open={displayLogin}
            onClose={this.onClose}
          />
        )}
        <Container>
          <Image
            src={KnaufLogoCloud}
            size="large"
            id="KnaufLogoCloud"
          />
          <Segment
            basic
            id="windowLanding"
          >
            <Grid
              columns="equal"
              id="cardContainer"
            >
              <Grid.Row>
                <Grid.Column
                  only="computer"
                  computer={2}
                />
                <Grid.Column
                  tablet={5}
                  computer={4}
                >
                  <Container>
                    <Card
                      className="infoEnterpriseCard"
                      onClick={() => this.addLogin(JobList.USER)}
                    >
                      <Image
                        src={user}
                        size="medium"
                        centered
                        className="infoEnterpriseImg"
                      />
                      <div className="infoEnterpriseText">
                        {t('title_user')}
                        {/* PARTICULIERS */}
                      </div>
                    </Card>
                  </Container>
                </Grid.Column>
                <Grid.Column tablet={5} computer={4}>
                  <Container>
                    <Card
                      className="infoEnterpriseCard"
                      onClick={() => this.addLogin(JobList.PRESCRIBER)}
                    >
                      <Image
                        src={prescripteurs}
                        size="medium"
                        centered
                        className="infoEnterpriseImg"
                      />
                      <div className="infoEnterpriseText">
                        {t('title_prescripteur')}
                        {/* PERSCRIPTEURS */}
                      </div>
                    </Card>
                  </Container>
                </Grid.Column>
                <Grid.Column tablet={5} computer={4}>
                  <Container>
                    <Card
                      className="infoEnterpriseCard"
                      onClick={() => this.addLogin(JobList.BUSINESS)}
                    >
                      <Image
                        src={entreprises}
                        size="medium"
                        centered
                        className="infoEnterpriseImg"
                      />
                      <div className="infoEnterpriseText">
                        {t('title_enterprise')}
                        {/* ENTREPRISES DE POSES */}
                      </div>
                    </Card>
                  </Container>
                </Grid.Column>
                <Grid.Column only="computer" width={2}></Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </Container>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
});

const mapActionToProps = {
  addLanguage,
  addRegister,
  addLogin,
  addSelectedUserType,
};

const TypeUser = connect(mapStateToProps, mapActionToProps)(ConnectedTypeUser);
export default translate('TypeUser')(TypeUser);



// WEBPACK FOOTER //
// ./src/components/Login/TypeUser.jsx